import {ValueObject} from '@s-ui/domain'

import {AdsListValueObject} from '../../ads/ValueObjects/AdsListValueObject.js'
import {FiltersAggregationsSearchValueObject} from './FiltersAggregationsSearchValueObject.js'

export class ResultsSearchValueObject extends ValueObject {
  #ads
  #aggregations
  #totalPages
  #totalResults

  constructor({ads, aggregations, totalPages, totalResults}) {
    super()
    this.#ads = ads
    this.#aggregations = aggregations
    this.#totalPages = totalPages
    this.#totalResults = totalResults
  }

  static createFromListingApi({data}) {
    return new ResultsSearchValueObject({
      ads: AdsListValueObject.createWithPaidAds({ads: data.items || [], paidAds: data.paidItems || []}),
      aggregations: FiltersAggregationsSearchValueObject.createFromListingApi({aggregations: data.aggregations || []}),
      totalPages: data.meta.totalPages,
      totalResults: data.meta.totalResults
    })
  }

  getAggregationsGroupedByName() {
    return this.#aggregations.getAggregationsGroupedByName()
  }

  get ads() {
    return this.#ads.value
  }

  get aggregations() {
    return this.#aggregations.value
  }

  get totalPages() {
    return this.#totalPages
  }

  get totalResults() {
    return this.#totalResults
  }

  get value() {
    return {
      ads: this.ads,
      aggregations: this.aggregations,
      totalPages: this.totalPages,
      totalResults: this.totalResults
    }
  }
}
